import { DropdownButton } from "components/common/DropdownButton"
import React from "react"

interface FilterDropdownButtonProps {
  closeMenu: () => void
  openMenu: () => void
  isMenuOpen: boolean
  ariaControls?: string
  appliedFiltersCount: number
}

const FilterDropdownButton = React.forwardRef<HTMLButtonElement, FilterDropdownButtonProps>(
  function FilterDropdownButton(props, ref) {
    const { isMenuOpen, openMenu, closeMenu, ariaControls, appliedFiltersCount } = props

    return (
      <DropdownButton
        isOpen={isMenuOpen}
        onClick={isMenuOpen ? closeMenu : openMenu}
        ariaControls={ariaControls}
        ref={ref}>
        Filter {appliedFiltersCount ? `(${appliedFiltersCount})` : ""}
      </DropdownButton>
    )
  },
)

export default FilterDropdownButton
